import React from "react";

interface RatingItem {
  label: string;
  percentage: number;
}

interface RatingSummaryProps {
  averageRating: number;
  totalRatings: number;
  totalReviews: number;
  breakdown: RatingItem[];
}

const RatingSummary: React.FC<RatingSummaryProps> = ({
  averageRating,
  totalRatings,
  totalReviews,
  breakdown,
}) => {
  return (
    <div className="px-4 py-2 max-w-sm bg-white shadow-md rounded-md border">
      <div className="flex items-center space-x-3 mb-4">
        <div className="bg-success text-white px-2 py-1 rounded-md text-xl font-bold">
          {averageRating.toFixed(1)}
        </div>
        <div>
          <p className="text-blue-700 font-semibold ps-2 ">Excellent</p>
          <p className="text-sm text-secondary ps-2">
            {totalRatings} Ratings, {totalReviews} Reviews
          </p>
        </div>
      </div>

      <div className="space-y-2 mb-4">
        {breakdown.map((item, index) => (
          <div key={index} className="flex items-center justify-between mb-2">
            <span className="w-24 text-sm text-gray-700">{item.label}</span>
            <div className="flex-1 mx-2 bg-gray-200 h-2 rounded">
              <div
                className="bg-success h-2 rounded"
                style={{ width: `${item.percentage}%` }}
              ></div>
            </div>
            <span className="text-sm text-gray-700">{item.percentage}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RatingSummary;
